import styled from 'styled-components';

export const Mapwrap = styled.div`
	 display:grid;
	 grid-template-rows: max-content auto;
	height:100%;
	width:100%;
	

	Button{
		white-space: nowrap;
	}

}
`;

export const SetBtnWrap = styled.div`
display:flex;
flex-direction: row;
position: absolute;
top: 0px;
z-index: 9;
background: var(--defaultBgColor);
left: 0;
right: 0;
padding: 4px;
border-bottom: 1px solid #dbdbdb;
box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
width: 100%;
align-items: center;
padding: 3px 20px;
justify-content: center;
box-sizing: border-box;

@media (max-width: 500px){
	text-align: left;
	padding: 3px 8px;
}

 h3{
	font-size: 20px;
	color: #4c4c4c;
	margin: 0px 24px 0px 0px;
	font-weight: 500;

	@media (max-width: 500px){
		font-size: 17px;
	}
 }

}

`;

export const MapHeader = styled.div`
	background-color:var(--defaultBgColor);
	display:flex;
	justify-content:space-between;
	align-items: center;
	flex-wrap:wrap;
	gap:0.5rem;

	>.right{
		display:flex;
		gap:0.5rem;
		align-items: center;
		flex-wrap:wrap;

		.info{
			font-size:0.85rem;
			color:#4E4E4E
		}
		.btn-container{
			display:flex;
			gap:0.5rem;
			flex-wrap:wrap;
		}
	}
	button{
		margin:0!important
	}
	h3{
		margin:0;
	}
	>.left{
		padding:0rem 0.5rem 1rem 0.5rem;
		span{
			font-size:0.8rem;
			color:#4E4E4E;
			display: flex;
    	align-items: center;
    	gap: 0.3rem;
    	margin-top: 0.5em;
		}
		svg{
			stroke:#4E4E4E;
			width:1em;
		}
	}

	@media screen and (max-width:768px){
		>.right{
			width:100%;
			justify-content:flex-end;
		}
	}
	
	@media onlyscreen  and (max-width: 600px) {
		padding:0rem 0rem 1rem 0rem;
		>.right {
			justify-content:flex-start;
			gap: 0.5rem;
			button{
				width:100%;
			}
			span{
				font-size:0.9rem;
			}
		}
		.btn-container{
			width:100%;
		}
	}
`;

export const MapHeaderLeft = styled.div`
	background-color:yellow;
`;
export const MapHeaderRight = styled.div`
	background-color:greem;
`;

export const SetHouseInfoContent = styled.div`
		position: absolute;
 		top: 16%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 9;
    max-width: 550px;
   
    text-align: center;
    padding: 1.125rem 1rem;
    border-radius: 5px;
   
		font-size: 1rem;
		font-weight: 500;
		box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
		min-width: 326px;
		 color: var(--btnLabel);
		 background: rgba(0,0,0,.54);
		backdrop-filter: blur(4px);
    -webkit-backdrop-filter: blur(4px);
`;

export const SetHouseBtn = styled.div`
		position: absolute;
		left: 50%;
    transform: translateX(-50%);
		top: 84%;
    z-index: 9;

		@media (max-width: 500px){
			top: 84%;
		}
`;

// ZoomControl: Google's zoom control shape (40 × 80 px, bottom right) in the theme's colours (ThemeContext variables),
// so it follows light and dark mode
export const ZoomPanel = styled.div`
	position: absolute;
	right: 10px;
	bottom: 24px;
	z-index: 9;
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 40px;
	border-radius: 3px;
	background: var(--controlBgColor);
	box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3);
	overflow: hidden;
`;

export const ZoomBtn = styled.button`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 40px;
	height: 39.5px;
	margin: 0;
	padding: 0;
	border: none;
	background: transparent;
	color: var(--defaultIconColor);
	cursor: pointer;

	&:hover:not(:disabled) {
		background: var(--controlHoverBgColor);
		color: var(--textHeadingColor);
	}

	&:focus-visible {
		outline: 2px solid var(--inputFocusBorderColor);
		outline-offset: -2px;
	}

	&:disabled {
		cursor: default;
		opacity: 0.4;
	}
`;

export const ZoomDivider = styled.span`
	width: 20px;
	height: 1px;
	background: var(--borderColor);
`;
